import React, { useEffect, useRef, useState } from "react";

interface AnimatedButtonProps {
  buttonText: string;
}

let animationInstance: any;

const AnimatedButton: React.FC<AnimatedButtonProps> = ({ buttonText }) => {
  const [isButtonHover, setIsButtonHover] = useState<boolean>(false);
  const buttonRef = useRef<HTMLDivElement>(null);
  const particlesRef = useRef<HTMLDivElement>(null);
  const lineMoveRef = useRef<HTMLDivElement>(null);
  const insideGlowRef = useRef<HTMLDivElement>(null);
  const bgGlowRef = useRef<HTMLDivElement>(null);
  const lottieContainerRef = useRef<HTMLDivElement>(null);
  const lottieContainerRef2 = useRef<HTMLDivElement>(null);


  useEffect(() => {
    if (isButtonHover) {
      const timer = setTimeout(async () => {
        if (lottieContainerRef.current) {
          const lottie = (await import("lottie-web")).default;
          animationInstance = lottie.loadAnimation({
            container: lottieContainerRef.current,
            renderer: "svg",
            loop: true,
            autoplay: true,
            path: "/documents/ButtonAnimation.json",
          });
        }
      }, 50);

      return () => clearTimeout(timer);
    }
    else {
      animationInstance?.destroy();
    }

  }, [isButtonHover])

  useEffect(() => {
    let lottieInstance: any;

    (async () => {
      if (particlesRef.current) {
        const lottie = (await import("lottie-web")).default;
        lottieInstance = lottie.loadAnimation({
          container: particlesRef.current,
          renderer: "svg",
          loop: true,
          autoplay: true,
          path: "/documents/lottie-animation.json",
        });
      }
    })();

    const animateOpacity = (
      element: HTMLDivElement | null,
      value: number,
      duration: number
    ) => {
      if (!element) return;
      element.style.transition = `opacity ${duration}ms ease`;
      element.style.opacity = `${value}`;
    };

    const animateTransformScale = (
      element: HTMLDivElement | null,
      scale: number,
      duration: number
    ) => {
      if (!element) return;
      element.style.transition = `transform ${duration}ms ease`;
      element.style.transformOrigin = `center`;
      element.style.transform = `scale(${scale}) translateZ(0px)`;
    };

    const handleMouseEnter = () => {
      // `a-115` animations
      setIsButtonHover(true);
      animateOpacity(particlesRef.current, 1, 500);
      animateOpacity(insideGlowRef.current, 1, 200);
      animateTransformScale(buttonRef.current, 1.05, 300);
    };

    const handleMouseLeave = () => {
      setIsButtonHover(false);
      animateOpacity(particlesRef.current, 0, 200);
      animateOpacity(insideGlowRef.current, 0, 200);
      animateTransformScale(buttonRef.current, 1, 200);
    };

    const animateLineMove = () => {
      if (!lineMoveRef.current) return;
      lineMoveRef.current.style.transition = `transform 4000ms linear`;
      lineMoveRef.current.style.transform = `translateX(-220%)`;

      setTimeout(() => {
        if (!lineMoveRef.current) return;
        lineMoveRef.current!.style.transition = `transform 0ms`;
        lineMoveRef.current!.style.transform = `translateX(220%)`;
        requestAnimationFrame(() => animateLineMove());
      }, 4000);
    };

    animateLineMove();
    if (buttonRef.current) {
      buttonRef.current.style.willChange = 'transform';
      buttonRef.current.addEventListener("mouseenter", handleMouseEnter);
      buttonRef.current.addEventListener("mouseleave", handleMouseLeave);
    }

    return () => {
      if (buttonRef.current) {
        buttonRef.current.removeEventListener("mouseenter", handleMouseEnter);
        buttonRef.current.removeEventListener("mouseleave", handleMouseLeave);
      }

      lottieInstance?.destroy();
    };
  }, []);

  return (
    <div
      data-adiuo="playBtn"
      data-wf--animated-cta--variant="base"
      className="animatedcta"
    >
      <div className="button-5" ref={buttonRef}>
        <a
          data-w-id="a4ac1f03-30d4-7cbe-9b9a-2c755a0e326b"
          href="/listing"
          className="button-stroke w-inline-block"

        >
          <div className="button-inside" >
            <div className="text-and-icon">
              <div className="icon-wrapper-2">
                <div
                  style={{
                    display: isButtonHover ? "block" : "none",
                    transform: "translate3d(0px, 0px, 0px) scale3d(1.2, 1.2, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                    opacity: 0.8,
                  }}
                  data-w-id="a4ac1f03-30d4-7cbe-9b9a-2c755a0e326f"
                  className="diamond-animation animated-section"
                  ref={lottieContainerRef}
                ></div>
                <div
                style={{ display: isButtonHover ? "none" : "block" }}
                  data-w-id="a4ac1f03-30d4-7cbe-9b9a-2c755a0e326f"
                  className="diamond-animation"
                  ref={lottieContainerRef2}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" width="500" height="500" style={{
                    width: "100%",
                    height: "100%",
                    transform: "translate3d(0,0,0)",
                    contentVisibility: "visible",
                  }}><defs>
                      <clipPath id="a"><path d="M0 0h500v500H0z" /></clipPath>
                      <clipPath id="b"><path d="M0 0h600v600H0z" /></clipPath>
                      <clipPath id="c"><path d="M0 0h600v600H0z" /></clipPath>
                    </defs>
                    <g clipPath="url(#a)"><g clipPath="url(#b)" transform="translate(-50 -50)" >
                      <g clipPath="url(#c)" >
                        <path d="M300 208h71.133L412 270.618 300 392m0-184h-71.133L188 270.618 300 392" strokeLinecap="round" strokeLinejoin="round" stroke="#11283E" strokeWidth="21" fill="none" />
                        <path strokeLinecap="round" strokeLinejoin="round" stroke="#11283E" strokeWidth="21" d="M10.5 10.5h224" fill="none" transform="translate(177.5 260.024)" /><g >
                          <path strokeLinecap="round" strokeLinejoin="round" stroke="#11283E" strokeWidth="21" d="M299.997 208h-29.64l-17.02 62.62L299.997 392" fill="none" />
                          <g transform="matrix(-.41667 0 0 1 321.875 155.5)" /></g>
                        <g >
                          <path strokeLinecap="round" strokeLinejoin="round" stroke="#11283E" strokeWidth="21" d="M300.003 208h29.64l17.02 62.62L300.003 392" fill="none" />
                          <g transform="matrix(.41667 0 0 1 278.125 155.5)" /></g>
                      </g></g>
                      <g ><g transform="translate(302.5 292.967)" />
                        <g transform="translate(302.5 292.967)" />
                        <g transform="translate(302.5 292.967)" />
                        <g transform="translate(302.5 292.967)" />
                      </g>
                    </g>
                  </svg>
                </div>


              </div>
              <div className="test-button">{buttonText}</div>
            </div>
            <div className="inside-glow-dv" ref={insideGlowRef}></div>
          </div>
          <div className="line-move" ref={lineMoveRef}></div>
        </a>
        <div className="particles-wrapper" style={{ pointerEvents: 'none' }}>
          <div className="particles" ref={particlesRef}></div>
          <div className="bg-glow" ref={bgGlowRef} style={{
            transform: "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
            transformStyle: "preserve-3d",
            filter: "blur(20px)",
          }}></div>
          <div className="circular-lottie none" ></div>

        </div>
      </div>
    </div>
  );
};

export default AnimatedButton;
